import React from "react";
import { Info } from "lucide-react";

import { Banner } from "@/main/react/component/Banner";

export function InfoBanner(props: {
    icon?: React.ElementType;
    title?: React.ReactNode;
    description: React.ReactNode;
    className?: string;
}) {
    const { icon, ...rest } = props;
    return <Banner variant="info" icon={icon ?? Info} {...rest} />;
}
